const COUNTRY_NAMES = new Intl.DisplayNames(['en'], { type: 'region' });

/** `KE` → "Kenya". The API stores the ISO code; the office reads a name. */
export function countryName(countryCode: string | null): string | null {
  if (!countryCode) return null;
  return COUNTRY_NAMES.of(countryCode) ?? countryCode;
}

/** "800 m" up to a kilometre, then "1.5 km": how a point zone's reach reads in a table or panel. */
export function formatRadius(radiusMeters: number): string {
  if (radiusMeters < 1000) return `${radiusMeters} m`;
  return `${Number((radiusMeters / 1000).toFixed(1))} km`;
}
